import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { CustomPagination } from "src/components/CustomPagination";
import { NoRowsOverlay } from "src/components/NoRowsOverlay";
import { useTranslation } from "src/hooks";
import { dataGridDefaults } from "src/utils/constant";
import { useGenGridCol } from "src/utils/HelperComp";
import LabelValuePair from "./components/LabelValuePair";
import { Box } from "src/components/MuiGenerals";
import {
  DisplayTransactionbatchsignature,
  MultisigDisplayData,
} from "../types";
import MultisigStatusBlock from "./components/MultisigStatusBlock";

function Content({
  data,
  refetchFn,
}: {
  data: MultisigDisplayData;
  refetchFn: () => Promise<void>;
}) {
  const { t } = useTranslation("assetManagement");

  const displayData = [
    {
      label: t("batch_id"),
      value: data.batch_id,
    },
    {
      label: t("multisig_status"),
      value: (
        <MultisigStatusBlock
          displayValue={data.multisign_status}
          rawValue={data.raw_multisign_status}
          batchId={data.batch_id}
          refetchFn={refetchFn}
        />
      ),
    },
    {
      label: t("required_signatures"),
      value: data.required_sig,
    },
    {
      label: t("completed_signatures"),
      value: data.completed_sig,
    },
    {
      label: t("created_date"),
      value: data.created_date,
    },
    {
      label: t("last_modified_date"),
      value: data.last_modified_date,
    },
    {
      label: t("signer_address"),
      value: data.signer_addresses,
    },
    {
      label: t("remarks"),
      value: data.remarks,
    },
  ];

  const columns: GridColumns<DisplayTransactionbatchsignature> = [
    // useGenGridCol("batch_id", t("batch_id")),
    useGenGridCol("signer_address", t("signer_address"), { minWidth: 240 }),
    useGenGridCol("result_code", t("result")),
    // useGenGridCol("is_verified", t("is_verified")),
    // useGenGridCol("signatures", "Signatures", {
    //   minWidth: 240,
    //   renderCell: renderSignaturesCell,
    // }),
    useGenGridCol("created_date", t("created_date")),
    useGenGridCol("last_modified_date", t("last_modified_date")),
  ];
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div
        style={{ display: "grid", gap: "16px", gridTemplateColumns: "1fr 1fr" }}
      >
        {displayData.map((item, index) => {
          if (item.label === t("remarks") && !item.value) {
            return null;
          }

          return <LabelValuePair key={index} {...item} />;
        })}
      </div>

      {data.transaction_batch_signatures && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "2px",
            ":before": {
              content: '""',
              display: "block",
              height: "1px",
              backgroundColor: "divider",
              mb: "16px",
            },
          }}
        >
          <div style={{ fontSize: "13px" }}>{t("signatures")}</div>
          <DataGrid
            {...dataGridDefaults}
            columns={columns}
            rows={data.transaction_batch_signatures}
            rowCount={data.transaction_batch_signatures.length}
            components={{
              NoRowsOverlay,
              Footer: CustomPagination,
            }}
            componentsProps={{
              footer: {
                totalRecords: data.transaction_batch_signatures.length,
              },
            }}
          />
        </Box>
      )}
    </div>
  );
}

export default Content;
